__turbopack_context__.v({
  "searchTitle": "watch-module__0ufTOG__searchTitle",
  "watchDramasBg": "watch-module__0ufTOG__watchDramasBg",
  "watchNow": "watch-module__0ufTOG__watchNow",
});
